/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { KokpitFeatureNameListDto } from './KokpitFeatureNameListDto';
import {
    KokpitFeatureNameListDtoFromJSON,
    KokpitFeatureNameListDtoFromJSONTyped,
    KokpitFeatureNameListDtoToJSON,
} from './KokpitFeatureNameListDto';

/**
 * 
 * @export
 * @interface KokpitPackageUpdateDto
 */
export interface KokpitPackageUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof KokpitPackageUpdateDto
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof KokpitPackageUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof KokpitPackageUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitPackageUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<KokpitFeatureNameListDto>}
     * @memberof KokpitPackageUpdateDto
     */
    features?: Array<KokpitFeatureNameListDto> | null;
}

/**
 * Check if a given object implements the KokpitPackageUpdateDto interface.
 */
export function instanceOfKokpitPackageUpdateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KokpitPackageUpdateDtoFromJSON(json: any): KokpitPackageUpdateDto {
    return KokpitPackageUpdateDtoFromJSONTyped(json, false);
}

export function KokpitPackageUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KokpitPackageUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'features': !exists(json, 'features') ? undefined : (json['features'] === null ? null : (json['features'] as Array<any>).map(KokpitFeatureNameListDtoFromJSON)),
    };
}

export function KokpitPackageUpdateDtoToJSON(value?: KokpitPackageUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'features': value.features === undefined ? undefined : (value.features === null ? null : (value.features as Array<any>).map(KokpitFeatureNameListDtoToJSON)),
    };
}

